import { useState } from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'

interface Props {
    icon: string,
    title: string,
    value: boolean,
    setValue: () => void
}

const MiniSwitch = ({
        icon,
        title,
        value,
        setValue
    }: Props
) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    const translateX = value ? 31 : 1

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <div
            style={{
                width: `100%`,
                height: `60px`,
                float: 'left',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                borderBottom: `1px solid ${Colors[theme ?? 'light'].borderLighter}`,
                color: Colors[theme ?? 'light'].text,
                backgroundColor: Colors[theme ?? 'light'].secondBackground
            }}
        >
            <div
                style={{
                    width: `60px`,
                    height: `60px`,
                    display: 'flex',
                    alignItems: `center`,
                    justifyContent: 'center',
                    fontSize: '1.2em'
                }}
            >
                <i className={icon}></i>
            </div>
            <div
                style={{
                    width: `calc(100% - 140px)`,
                    height: `60px`,
                    display: 'flex',
                    alignItems: `center`,
                    justifyContent: 'flex-start',
                    fontSize: '1.2em',
                    fontFamily: 'UbuntuBold'
                }}
            >
                {title}:
            </div>
            <div
                style={{
                    width: `80px`,
                    height: `60px`,
                    display: 'flex',
                    alignItems: `center`,
                    justifyContent: 'center'
                }}
            >
                <div
                    style={{
                        width: `60px`,
                        height: `30px`,
                        float: 'left',
                        position: 'relative',
                        border: `1px solid ${Colors[theme ?? 'light'].app}`,
                        borderRadius: '15px',
                        boxSizing: 'border-box',
                        transition: 'all 0.2s'
                    }}
                >
                    <div
                        style={{
                            width: `26px`,
                            height: `26px`,
                            float: 'left',
                            cursor: 'pointer',
                            position: 'absolute',
                            top: '1px',
                            borderRadius: '13px',
                            backgroundColor: isHover
                                ? Colors[theme ?? 'light'].activeTint
                                : Colors[theme ?? 'light'].app,
                            transform: `translateX(${translateX}px)`,
                            transition: 'all 0.2s'
                        }}
                        onClick={setValue}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    ></div>
                </div>
            </div>
        </div>
    )
}

export default MiniSwitch